import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Icon from '@components/common/atoms/Icon';
import SectionEyebrow from './SectionEyebrow';
import { FEATURES } from '../../constants/landingPageConstants';

const LandingFeatures: React.FC = () => {
  return (
    <Box component="section" id="features" className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-8 lg:py-28">
      <Box className="mx-auto max-w-2xl text-center">
        <SectionEyebrow>What the system offers</SectionEyebrow>
        <Typography component="h2" className="mt-4 text-3xl font-bold tracking-tight sm:text-4xl">
          Everything HR needs, in one place
        </Typography>
        <Typography component="p" className="mt-4 text-lg text-slate-600 dark:text-slate-400">
          A complete suite of tools designed to simplify every part of the employee lifecycle —
          from the first day to every day after.
        </Typography>
      </Box>

      <Box className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {FEATURES.map((feature) => (
          <Box
            key={feature.title}
            className="group rounded-2xl border border-slate-200/80 bg-white p-6 shadow-sm transition-all duration-200 hover:-translate-y-1 hover:border-indigo-300 hover:shadow-xl hover:shadow-indigo-500/10 dark:border-slate-800/80 dark:bg-slate-900 dark:hover:border-indigo-700"
          >
            <Box className="flex h-12 w-12 items-center justify-center rounded-xl bg-gradient-to-br from-indigo-600 to-purple-600 text-white shadow-lg shadow-indigo-500/30 transition-transform duration-200 group-hover:scale-110">
              <Icon name={feature.icon} size={24} className="text-white" />
            </Box>
            <Typography component="h3" className="mt-5 text-lg font-bold">{feature.title}</Typography>
            <Typography component="p" className="mt-2 text-sm leading-relaxed text-slate-600 dark:text-slate-400">
              {feature.description}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default LandingFeatures;
